export default {
    'en-US': {
        responsible: '<strong>Responsible:</strong> {name}',
    },
    'es-ES': {
        responsible: '<strong>Responsable:</strong> {name}',
    },
    'pt-BR': {
        responsible: '<strong>Responsável:</strong> {name}',
    },
}
